import React, { memo } from 'react'
import { ClientSecureWrapper } from 'src/components/layout/client/ClientSecureWrapper'
import { PIICollection } from 'src/components/personal-information-collection/PIICollection'

const PIICollectionPageComponent = () => {
  return (
    <ClientSecureWrapper>
      <PIICollection />
    </ClientSecureWrapper>
  )
}

export const PIICollectionPage = memo(PIICollectionPageComponent)
